import { useContext } from 'react';
import { CommonContext } from './CommonContext';
export const useCommonCtx = () => useContext(CommonContext)
// FIXME replace everwhere
export const useCtxParams = () => useCommonCtx().state.params